import {SankeyFlow} from 'common/widgets/sankey-chart/models/sankey-flow';

export const sankeyChartData = new SankeyFlow(
  {
    breakdowns: [
      {
        timeBucketsFromStart: null,
        segments: [],
        timeBucketsFromPrev: null,
        totalCount: `35931`,
        timePercentilesFromPrev: [],
        timePercentilesFromStart: [],
      },
    ],
    steps: [
      {
        nodes: [
          {
            breakdowns: [
              {
                timeBucketsFromStart: null,
                segments: [],
                timeBucketsFromPrev: null,
                totalCount: `22490`,
                timePercentilesFromPrev: [],
                timePercentilesFromStart: [],
              },
            ],
            segments: [{values: [], value: `insights`, label: `Report name`}],
            totalCount: `22490`,
            edges: [
              {
                breakdowns: [
                  {
                    timeBucketsFromStart: null,
                    segments: [],
                    timeBucketsFromPrev: null,
                    totalCount: `9895`,
                    timePercentilesFromPrev: [],
                    timePercentilesFromStart: [],
                  },
                ],
                segments: [{values: [], value: `insights`, label: `Report name`}],
                totalCount: `9895`,
                step: `1`,
                type: `NORMAL`,
                event: `Viewed report`,
                isComputed: false,
              },
              {
                breakdowns: [
                  {
                    timeBucketsFromStart: null,
                    segments: [],
                    timeBucketsFromPrev: null,
                    totalCount: `1536`,
                    timePercentilesFromPrev: [],
                    timePercentilesFromStart: [],
                  },
                ],
                segments: [{values: [], value: `explore`, label: `Report name`}],
                totalCount: `1536`,
                step: `1`,
                type: `NORMAL`,
                event: `Viewed report`,
                isComputed: false,
              },
              {
                breakdowns: [
                  {
                    timeBucketsFromStart: null,
                    segments: [],
                    timeBucketsFromPrev: null,
                    totalCount: `2933`,
                    timePercentilesFromPrev: [],
                    timePercentilesFromStart: [],
                  },
                ],
                segments: [{values: [], value: `live`, label: `Report name`}],
                totalCount: `2933`,
                step: `1`,
                type: `NORMAL`,
                event: `Viewed report`,
                isComputed: false,
              },
              {
                breakdowns: [
                  {
                    timeBucketsFromStart: null,
                    segments: [],
                    timeBucketsFromPrev: null,
                    totalCount: `1456`,
                    timePercentilesFromPrev: [],
                    timePercentilesFromStart: [],
                  },
                ],
                segments: [{values: [], value: `user_settings`, label: `Report name`}],
                totalCount: `1456`,
                step: `1`,
                type: `NORMAL`,
                event: `Viewed report`,
                isComputed: false,
              },
              {
                breakdowns: [
                  {
                    timeBucketsFromStart: null,
                    segments: [],
                    timeBucketsFromPrev: null,
                    totalCount: `1764`,
                    timePercentilesFromPrev: [],
                    timePercentilesFromStart: [],
                  },
                ],
                segments: [{values: [], value: `dashboard`, label: `Report name`}],
                totalCount: `1764`,
                step: `1`,
                type: `NORMAL`,
                event: `Viewed report`,
                isComputed: false,
              },
              {
                breakdowns: [
                  {
                    timeBucketsFromStart: null,
                    segments: [],
                    timeBucketsFromPrev: null,
                    totalCount: `2445`,
                    timePercentilesFromPrev: [],
                    timePercentilesFromStart: [],
                  },
                ],
                segments: [],
                totalCount: `2445`,
                step: `1`,
                type: `PRUNED`,
                event: ``,
                isComputed: false,
              },
              {
                breakdowns: [
                  {
                    timeBucketsFromStart: null,
                    segments: [],
                    timeBucketsFromPrev: null,
                    totalCount: `2461`,
                    timePercentilesFromPrev: [],
                    timePercentilesFromStart: [],
                  },
                ],
                segments: [],
                totalCount: `2461`,
                step: `1`,
                type: `DROPOFF`,
                event: ``,
                isComputed: false,
              },
            ],
            type: `ANCHOR`,
            event: `Viewed report`,
            isComputed: false,
          },
          {
            breakdowns: [
              {
                timeBucketsFromStart: null,
                segments: [],
                timeBucketsFromPrev: null,
                totalCount: `3215`,
                timePercentilesFromPrev: [],
                timePercentilesFromStart: [],
              },
            ],
            segments: [{values: [], value: `explore`, label: `Report name`}],
            totalCount: `3215`,
            edges: [
              {
                breakdowns: [
                  {
                    timeBucketsFromStart: null,
                    segments: [],
                    timeBucketsFromPrev: null,
                    totalCount: `2147`,
                    timePercentilesFromPrev: [],
                    timePercentilesFromStart: [],
                  },
                ],
                segments: [{values: [], value: `explore`, label: `Report name`}],
                totalCount: `2147`,
                step: `1`,
                type: `NORMAL`,
                event: `Viewed report`,
                isComputed: false,
              },
              {
                breakdowns: [
                  {
                    timeBucketsFromStart: null,
                    segments: [],
                    timeBucketsFromPrev: null,
                    totalCount: `97`,
                    timePercentilesFromPrev: [],
                    timePercentilesFromStart: [],
                  },
                ],
                segments: [{values: [], value: `live`, label: `Report name`}],
                totalCount: `97`,
                step: `1`,
                type: `NORMAL`,
                event: `Viewed report`,
                isComputed: false,
              },
              {
                breakdowns: [
                  {
                    timeBucketsFromStart: null,
                    segments: [],
                    timeBucketsFromPrev: null,
                    totalCount: `329`,
                    timePercentilesFromPrev: [],
                    timePercentilesFromStart: [],
                  },
                ],
                segments: [{values: [], value: `insights`, label: `Report name`}],
                totalCount: `329`,
                step: `1`,
                type: `NORMAL`,
                event: `Viewed report`,
                isComputed: false,
              },
              {
                breakdowns: [
                  {
                    timeBucketsFromStart: null,
                    segments: [],
                    timeBucketsFromPrev: null,
                    totalCount: `142`,
                    timePercentilesFromPrev: [],
                    timePercentilesFromStart: [],
                  },
                ],
                segments: [{values: [], value: `dashboard`, label: `Report name`}],
                totalCount: `142`,
                step: `1`,
                type: `NORMAL`,
                event: `Viewed report`,
                isComputed: false,
              },
              {
                breakdowns: [
                  {
                    timeBucketsFromStart: null,
                    segments: [],
                    timeBucketsFromPrev: null,
                    totalCount: `72`,
                    timePercentilesFromPrev: [],
                    timePercentilesFromStart: [],
                  },
                ],
                segments: [{values: [], value: `user_settings`, label: `Report name`}],
                totalCount: `72`,
                step: `1`,
                type: `NORMAL`,
                event: `Viewed report`,
                isComputed: false,
              },
              {
                breakdowns: [
                  {
                    timeBucketsFromStart: null,
                    segments: [],
                    timeBucketsFromPrev: null,
                    totalCount: `255`,
                    timePercentilesFromPrev: [],
                    timePercentilesFromStart: [],
                  },
                ],
                segments: [],
                totalCount: `255`,
                step: `1`,
                type: `PRUNED`,
                event: ``,
                isComputed: false,
              },
              {
                breakdowns: [
                  {
                    timeBucketsFromStart: null,
                    segments: [],
                    timeBucketsFromPrev: null,
                    totalCount: `173`,
                    timePercentilesFromPrev: [],
                    timePercentilesFromStart: [],
                  },
                ],
                segments: [],
                totalCount: `173`,
                step: `1`,
                type: `DROPOFF`,
                event: ``,
                isComputed: false,
              },
            ],
            type: `ANCHOR`,
            event: `Viewed report`,
            isComputed: false,
          },
          {
            breakdowns: [
              {
                timeBucketsFromStart: null,
                segments: [],
                timeBucketsFromPrev: null,
                totalCount: `3051`,
                timePercentilesFromPrev: [],
                timePercentilesFromStart: [],
              },
            ],
            segments: [{values: [], value: `dashboard`, label: `Report name`}],
            totalCount: `3051`,
            edges: [
              {
                breakdowns: [
                  {
                    timeBucketsFromStart: null,
                    segments: [],
                    timeBucketsFromPrev: null,
                    totalCount: `1370`,
                    timePercentilesFromPrev: [],
                    timePercentilesFromStart: [],
                  },
                ],
                segments: [{values: [], value: `dashboard`, label: `Report name`}],
                totalCount: `1370`,
                step: `1`,
                type: `NORMAL`,
                event: `Viewed report`,
                isComputed: false,
              },
              {
                breakdowns: [
                  {
                    timeBucketsFromStart: null,
                    segments: [],
                    timeBucketsFromPrev: null,
                    totalCount: `230`,
                    timePercentilesFromPrev: [],
                    timePercentilesFromStart: [],
                  },
                ],
                segments: [{values: [], value: `explore`, label: `Report name`}],
                totalCount: `230`,
                step: `1`,
                type: `NORMAL`,
                event: `Viewed report`,
                isComputed: false,
              },
              {
                breakdowns: [
                  {
                    timeBucketsFromStart: null,
                    segments: [],
                    timeBucketsFromPrev: null,
                    totalCount: `771`,
                    timePercentilesFromPrev: [],
                    timePercentilesFromStart: [],
                  },
                ],
                segments: [{values: [], value: `insights`, label: `Report name`}],
                totalCount: `771`,
                step: `1`,
                type: `NORMAL`,
                event: `Viewed report`,
                isComputed: false,
              },
              {
                breakdowns: [
                  {
                    timeBucketsFromStart: null,
                    segments: [],
                    timeBucketsFromPrev: null,
                    totalCount: `76`,
                    timePercentilesFromPrev: [],
                    timePercentilesFromStart: [],
                  },
                ],
                segments: [{values: [], value: `live`, label: `Report name`}],
                totalCount: `76`,
                step: `1`,
                type: `NORMAL`,
                event: `Viewed report`,
                isComputed: false,
              },
              {
                breakdowns: [
                  {
                    timeBucketsFromStart: null,
                    segments: [],
                    timeBucketsFromPrev: null,
                    totalCount: `63`,
                    timePercentilesFromPrev: [],
                    timePercentilesFromStart: [],
                  },
                ],
                segments: [{values: [], value: `user_settings`, label: `Report name`}],
                totalCount: `63`,
                step: `1`,
                type: `NORMAL`,
                event: `Viewed report`,
                isComputed: false,
              },
              {
                breakdowns: [
                  {
                    timeBucketsFromStart: null,
                    segments: [],
                    timeBucketsFromPrev: null,
                    totalCount: `338`,
                    timePercentilesFromPrev: [],
                    timePercentilesFromStart: [],
                  },
                ],
                segments: [],
                totalCount: `338`,
                step: `1`,
                type: `PRUNED`,
                event: ``,
                isComputed: false,
              },
              {
                breakdowns: [
                  {
                    timeBucketsFromStart: null,
                    segments: [],
                    timeBucketsFromPrev: null,
                    totalCount: `203`,
                    timePercentilesFromPrev: [],
                    timePercentilesFromStart: [],
                  },
                ],
                segments: [],
                totalCount: `203`,
                step: `1`,
                type: `DROPOFF`,
                event: ``,
                isComputed: false,
              },
            ],
            type: `ANCHOR`,
            event: `Viewed report`,
            isComputed: false,
          },
          {
            breakdowns: [
              {
                timeBucketsFromStart: null,
                segments: [],
                timeBucketsFromPrev: null,
                totalCount: `2107`,
                timePercentilesFromPrev: [],
                timePercentilesFromStart: [],
              },
            ],
            segments: [{values: [], value: `live`, label: `Report name`}],
            totalCount: `2107`,
            edges: [
              {
                breakdowns: [
                  {
                    timeBucketsFromStart: null,
                    segments: [],
                    timeBucketsFromPrev: null,
                    totalCount: `1126`,
                    timePercentilesFromPrev: [],
                    timePercentilesFromStart: [],
                  },
                ],
                segments: [{values: [], value: `live`, label: `Report name`}],
                totalCount: `1126`,
                step: `1`,
                type: `NORMAL`,
                event: `Viewed report`,
                isComputed: false,
              },
              {
                breakdowns: [
                  {
                    timeBucketsFromStart: null,
                    segments: [],
                    timeBucketsFromPrev: null,
                    totalCount: `227`,
                    timePercentilesFromPrev: [],
                    timePercentilesFromStart: [],
                  },
                ],
                segments: [{values: [], value: `explore`, label: `Report name`}],
                totalCount: `227`,
                step: `1`,
                type: `NORMAL`,
                event: `Viewed report`,
                isComputed: false,
              },
              {
                breakdowns: [
                  {
                    timeBucketsFromStart: null,
                    segments: [],
                    timeBucketsFromPrev: null,
                    totalCount: `350`,
                    timePercentilesFromPrev: [],
                    timePercentilesFromStart: [],
                  },
                ],
                segments: [{values: [], value: `insights`, label: `Report name`}],
                totalCount: `350`,
                step: `1`,
                type: `NORMAL`,
                event: `Viewed report`,
                isComputed: false,
              },
              {
                breakdowns: [
                  {
                    timeBucketsFromStart: null,
                    segments: [],
                    timeBucketsFromPrev: null,
                    totalCount: `43`,
                    timePercentilesFromPrev: [],
                    timePercentilesFromStart: [],
                  },
                ],
                segments: [{values: [], value: `user_settings`, label: `Report name`}],
                totalCount: `43`,
                step: `1`,
                type: `NORMAL`,
                event: `Viewed report`,
                isComputed: false,
              },
              {
                breakdowns: [
                  {
                    timeBucketsFromStart: null,
                    segments: [],
                    timeBucketsFromPrev: null,
                    totalCount: `77`,
                    timePercentilesFromPrev: [],
                    timePercentilesFromStart: [],
                  },
                ],
                segments: [{values: [], value: `dashboard`, label: `Report name`}],
                totalCount: `77`,
                step: `1`,
                type: `NORMAL`,
                event: `Viewed report`,
                isComputed: false,
              },
              {
                breakdowns: [
                  {
                    timeBucketsFromStart: null,
                    segments: [],
                    timeBucketsFromPrev: null,
                    totalCount: `158`,
                    timePercentilesFromPrev: [],
                    timePercentilesFromStart: [],
                  },
                ],
                segments: [],
                totalCount: `158`,
                step: `1`,
                type: `PRUNED`,
                event: ``,
                isComputed: false,
              },
              {
                breakdowns: [
                  {
                    timeBucketsFromStart: null,
                    segments: [],
                    timeBucketsFromPrev: null,
                    totalCount: `126`,
                    timePercentilesFromPrev: [],
                    timePercentilesFromStart: [],
                  },
                ],
                segments: [],
                totalCount: `126`,
                step: `1`,
                type: `DROPOFF`,
                event: ``,
                isComputed: false,
              },
            ],
            type: `ANCHOR`,
            event: `Viewed report`,
            isComputed: false,
          },
          {
            breakdowns: [
              {
                timeBucketsFromStart: null,
                segments: [],
                timeBucketsFromPrev: null,
                totalCount: `1514`,
                timePercentilesFromPrev: [],
                timePercentilesFromStart: [],
              },
            ],
            segments: [{values: [], value: `funnels`, label: `Report name`}],
            totalCount: `1514`,
            edges: [
              {
                breakdowns: [
                  {
                    timeBucketsFromStart: null,
                    segments: [],
                    timeBucketsFromPrev: null,
                    totalCount: `56`,
                    timePercentilesFromPrev: [],
                    timePercentilesFromStart: [],
                  },
                ],
                segments: [{values: [], value: `live`, label: `Report name`}],
                totalCount: `56`,
                step: `1`,
                type: `NORMAL`,
                event: `Viewed report`,
                isComputed: false,
              },
              {
                breakdowns: [
                  {
                    timeBucketsFromStart: null,
                    segments: [],
                    timeBucketsFromPrev: null,
                    totalCount: `64`,
                    timePercentilesFromPrev: [],
                    timePercentilesFromStart: [],
                  },
                ],
                segments: [{values: [], value: `explore`, label: `Report name`}],
                totalCount: `64`,
                step: `1`,
                type: `NORMAL`,
                event: `Viewed report`,
                isComputed: false,
              },
              {
                breakdowns: [
                  {
                    timeBucketsFromStart: null,
                    segments: [],
                    timeBucketsFromPrev: null,
                    totalCount: `315`,
                    timePercentilesFromPrev: [],
                    timePercentilesFromStart: [],
                  },
                ],
                segments: [{values: [], value: `insights`, label: `Report name`}],
                totalCount: `315`,
                step: `1`,
                type: `NORMAL`,
                event: `Viewed report`,
                isComputed: false,
              },
              {
                breakdowns: [
                  {
                    timeBucketsFromStart: null,
                    segments: [],
                    timeBucketsFromPrev: null,
                    totalCount: `115`,
                    timePercentilesFromPrev: [],
                    timePercentilesFromStart: [],
                  },
                ],
                segments: [{values: [], value: `dashboard`, label: `Report name`}],
                totalCount: `115`,
                step: `1`,
                type: `NORMAL`,
                event: `Viewed report`,
                isComputed: false,
              },
              {
                breakdowns: [
                  {
                    timeBucketsFromStart: null,
                    segments: [],
                    timeBucketsFromPrev: null,
                    totalCount: `14`,
                    timePercentilesFromPrev: [],
                    timePercentilesFromStart: [],
                  },
                ],
                segments: [{values: [], value: `user_settings`, label: `Report name`}],
                totalCount: `14`,
                step: `1`,
                type: `NORMAL`,
                event: `Viewed report`,
                isComputed: false,
              },
              {
                breakdowns: [
                  {
                    timeBucketsFromStart: null,
                    segments: [],
                    timeBucketsFromPrev: null,
                    totalCount: `836`,
                    timePercentilesFromPrev: [],
                    timePercentilesFromStart: [],
                  },
                ],
                segments: [],
                totalCount: `836`,
                step: `1`,
                type: `PRUNED`,
                event: ``,
                isComputed: false,
              },
              {
                breakdowns: [
                  {
                    timeBucketsFromStart: null,
                    segments: [],
                    timeBucketsFromPrev: null,
                    totalCount: `114`,
                    timePercentilesFromPrev: [],
                    timePercentilesFromStart: [],
                  },
                ],
                segments: [],
                totalCount: `114`,
                step: `1`,
                type: `DROPOFF`,
                event: ``,
                isComputed: false,
              },
            ],
            type: `ANCHOR`,
            event: `Viewed report`,
            isComputed: false,
          },
          {
            breakdowns: [
              {
                timeBucketsFromStart: null,
                segments: [],
                timeBucketsFromPrev: null,
                totalCount: `3554`,
                timePercentilesFromPrev: [],
                timePercentilesFromStart: [],
              },
            ],
            segments: [],
            totalCount: `3554`,
            edges: [
              {
                breakdowns: [
                  {
                    timeBucketsFromStart: null,
                    segments: [],
                    timeBucketsFromPrev: null,
                    totalCount: `303`,
                    timePercentilesFromPrev: [],
                    timePercentilesFromStart: [],
                  },
                ],
                segments: [{values: [], value: `dashboard`, label: `Report name`}],
                totalCount: `303`,
                step: `1`,
                type: `NORMAL`,
                event: `Viewed report`,
                isComputed: false,
              },
              {
                breakdowns: [
                  {
                    timeBucketsFromStart: null,
                    segments: [],
                    timeBucketsFromPrev: null,
                    totalCount: `85`,
                    timePercentilesFromPrev: [],
                    timePercentilesFromStart: [],
                  },
                ],
                segments: [{values: [], value: `live`, label: `Report name`}],
                totalCount: `85`,
                step: `1`,
                type: `NORMAL`,
                event: `Viewed report`,
                isComputed: false,
              },
              {
                breakdowns: [
                  {
                    timeBucketsFromStart: null,
                    segments: [],
                    timeBucketsFromPrev: null,
                    totalCount: `308`,
                    timePercentilesFromPrev: [],
                    timePercentilesFromStart: [],
                  },
                ],
                segments: [{values: [], value: `explore`, label: `Report name`}],
                totalCount: `308`,
                step: `1`,
                type: `NORMAL`,
                event: `Viewed report`,
                isComputed: false,
              },
              {
                breakdowns: [
                  {
                    timeBucketsFromStart: null,
                    segments: [],
                    timeBucketsFromPrev: null,
                    totalCount: `690`,
                    timePercentilesFromPrev: [],
                    timePercentilesFromStart: [],
                  },
                ],
                segments: [{values: [], value: `insights`, label: `Report name`}],
                totalCount: `690`,
                step: `1`,
                type: `NORMAL`,
                event: `Viewed report`,
                isComputed: false,
              },
              {
                breakdowns: [
                  {
                    timeBucketsFromStart: null,
                    segments: [],
                    timeBucketsFromPrev: null,
                    totalCount: `310`,
                    timePercentilesFromPrev: [],
                    timePercentilesFromStart: [],
                  },
                ],
                segments: [{values: [], value: `user_settings`, label: `Report name`}],
                totalCount: `310`,
                step: `1`,
                type: `NORMAL`,
                event: `Viewed report`,
                isComputed: false,
              },
              {
                breakdowns: [
                  {
                    timeBucketsFromStart: null,
                    segments: [],
                    timeBucketsFromPrev: null,
                    totalCount: `1606`,
                    timePercentilesFromPrev: [],
                    timePercentilesFromStart: [],
                  },
                ],
                segments: [],
                totalCount: `1606`,
                step: `1`,
                type: `PRUNED`,
                event: ``,
                isComputed: false,
              },
              {
                breakdowns: [
                  {
                    timeBucketsFromStart: null,
                    segments: [],
                    timeBucketsFromPrev: null,
                    totalCount: `252`,
                    timePercentilesFromPrev: [],
                    timePercentilesFromStart: [],
                  },
                ],
                segments: [],
                totalCount: `252`,
                step: `1`,
                type: `DROPOFF`,
                event: ``,
                isComputed: false,
              },
            ],
            type: `PRUNED`,
            event: ``,
            isComputed: false,
          },
        ],
      },
      {
        nodes: [
          {
            breakdowns: [
              {
                timeBucketsFromStart: null,
                segments: [],
                timeBucketsFromPrev: null,
                totalCount: `12350`,
                timePercentilesFromPrev: [],
                timePercentilesFromStart: [],
              },
            ],
            segments: [{values: [], value: `insights`, label: `Report name`}],
            totalCount: `12350`,
            edges: [
              {
                breakdowns: [
                  {
                    timeBucketsFromStart: null,
                    segments: [],
                    timeBucketsFromPrev: null,
                    totalCount: `7343`,
                    timePercentilesFromPrev: [],
                    timePercentilesFromStart: [],
                  },
                ],
                segments: [{values: [], value: `insights`, label: `Report name`}],
                totalCount: `7343`,
                step: `2`,
                type: `NORMAL`,
                event: `Viewed report`,
                isComputed: false,
              },
              {
                breakdowns: [
                  {
                    timeBucketsFromStart: null,
                    segments: [],
                    timeBucketsFromPrev: null,
                    totalCount: `377`,
                    timePercentilesFromPrev: [],
                    timePercentilesFromStart: [],
                  },
                ],
                segments: [{values: [], value: `funnels`, label: `Report name`}],
                totalCount: `377`,
                step: `2`,
                type: `NORMAL`,
                event: `Viewed report`,
                isComputed: false,
              },
              {
                breakdowns: [
                  {
                    timeBucketsFromStart: null,
                    segments: [],
                    timeBucketsFromPrev: null,
                    totalCount: `1050`,
                    timePercentilesFromPrev: [],
                    timePercentilesFromStart: [],
                  },
                ],
                segments: [{values: [], value: `live`, label: `Report name`}],
                totalCount: `1050`,
                step: `2`,
                type: `NORMAL`,
                event: `Viewed report`,
                isComputed: false,
              },
              {
                breakdowns: [
                  {
                    timeBucketsFromStart: null,
                    segments: [],
                    timeBucketsFromPrev: null,
                    totalCount: `780`,
                    timePercentilesFromPrev: [],
                    timePercentilesFromStart: [],
                  },
                ],
                segments: [{values: [], value: `dashboard`, label: `Report name`}],
                totalCount: `780`,
                step: `2`,
                type: `NORMAL`,
                event: `Viewed report`,
                isComputed: false,
              },
              {
                breakdowns: [
                  {
                    timeBucketsFromStart: null,
                    segments: [],
                    timeBucketsFromPrev: null,
                    totalCount: `600`,
                    timePercentilesFromPrev: [],
                    timePercentilesFromStart: [],
                  },
                ],
                segments: [{values: [], value: `explore`, label: `Report name`}],
                totalCount: `600`,
                step: `2`,
                type: `NORMAL`,
                event: `Viewed report`,
                isComputed: false,
              },
              {
                breakdowns: [
                  {
                    timeBucketsFromStart: null,
                    segments: [],
                    timeBucketsFromPrev: null,
                    totalCount: `1218`,
                    timePercentilesFromPrev: [],
                    timePercentilesFromStart: [],
                  },
                ],
                segments: [],
                totalCount: `1218`,
                step: `2`,
                type: `PRUNED`,
                event: ``,
                isComputed: false,
              },
              {
                breakdowns: [
                  {
                    timeBucketsFromStart: null,
                    segments: [],
                    timeBucketsFromPrev: null,
                    totalCount: `982`,
                    timePercentilesFromPrev: [],
                    timePercentilesFromStart: [],
                  },
                ],
                segments: [],
                totalCount: `982`,
                step: `2`,
                type: `DROPOFF`,
                event: ``,
                isComputed: false,
              },
            ],
            type: `NORMAL`,
            event: `Viewed report`,
            isComputed: false,
          },
          {
            breakdowns: [
              {
                timeBucketsFromStart: null,
                segments: [],
                timeBucketsFromPrev: null,
                totalCount: `4512`,
                timePercentilesFromPrev: [],
                timePercentilesFromStart: [],
              },
            ],
            segments: [{values: [], value: `explore`, label: `Report name`}],
            totalCount: `4512`,
            edges: [
              {
                breakdowns: [
                  {
                    timeBucketsFromStart: null,
                    segments: [],
                    timeBucketsFromPrev: null,
                    totalCount: `532`,
                    timePercentilesFromPrev: [],
                    timePercentilesFromStart: [],
                  },
                ],
                segments: [{values: [], value: `insights`, label: `Report name`}],
                totalCount: `532`,
                step: `2`,
                type: `NORMAL`,
                event: `Viewed report`,
                isComputed: false,
              },
              {
                breakdowns: [
                  {
                    timeBucketsFromStart: null,
                    segments: [],
                    timeBucketsFromPrev: null,
                    totalCount: `2834`,
                    timePercentilesFromPrev: [],
                    timePercentilesFromStart: [],
                  },
                ],
                segments: [{values: [], value: `explore`, label: `Report name`}],
                totalCount: `2834`,
                step: `2`,
                type: `NORMAL`,
                event: `Viewed report`,
                isComputed: false,
              },
              {
                breakdowns: [
                  {
                    timeBucketsFromStart: null,
                    segments: [],
                    timeBucketsFromPrev: null,
                    totalCount: `62`,
                    timePercentilesFromPrev: [],
                    timePercentilesFromStart: [],
                  },
                ],
                segments: [{values: [], value: `funnels`, label: `Report name`}],
                totalCount: `62`,
                step: `2`,
                type: `NORMAL`,
                event: `Viewed report`,
                isComputed: false,
              },
              {
                breakdowns: [
                  {
                    timeBucketsFromStart: null,
                    segments: [],
                    timeBucketsFromPrev: null,
                    totalCount: `151`,
                    timePercentilesFromPrev: [],
                    timePercentilesFromStart: [],
                  },
                ],
                segments: [{values: [], value: `live`, label: `Report name`}],
                totalCount: `151`,
                step: `2`,
                type: `NORMAL`,
                event: `Viewed report`,
                isComputed: false,
              },
              {
                breakdowns: [
                  {
                    timeBucketsFromStart: null,
                    segments: [],
                    timeBucketsFromPrev: null,
                    totalCount: `202`,
                    timePercentilesFromPrev: [],
                    timePercentilesFromStart: [],
                  },
                ],
                segments: [{values: [], value: `dashboard`, label: `Report name`}],
                totalCount: `202`,
                step: `2`,
                type: `NORMAL`,
                event: `Viewed report`,
                isComputed: false,
              },
              {
                breakdowns: [
                  {
                    timeBucketsFromStart: null,
                    segments: [],
                    timeBucketsFromPrev: null,
                    totalCount: `458`,
                    timePercentilesFromPrev: [],
                    timePercentilesFromStart: [],
                  },
                ],
                segments: [],
                totalCount: `458`,
                step: `2`,
                type: `PRUNED`,
                event: ``,
                isComputed: false,
              },
              {
                breakdowns: [
                  {
                    timeBucketsFromStart: null,
                    segments: [],
                    timeBucketsFromPrev: null,
                    totalCount: `273`,
                    timePercentilesFromPrev: [],
                    timePercentilesFromStart: [],
                  },
                ],
                segments: [],
                totalCount: `273`,
                step: `2`,
                type: `DROPOFF`,
                event: ``,
                isComputed: false,
              },
            ],
            type: `NORMAL`,
            event: `Viewed report`,
            isComputed: false,
          },
          {
            breakdowns: [
              {
                timeBucketsFromStart: null,
                segments: [],
                timeBucketsFromPrev: null,
                totalCount: `4373`,
                timePercentilesFromPrev: [],
                timePercentilesFromStart: [],
              },
            ],
            segments: [{values: [], value: `live`, label: `Report name`}],
            totalCount: `4373`,
            edges: [
              {
                breakdowns: [
                  {
                    timeBucketsFromStart: null,
                    segments: [],
                    timeBucketsFromPrev: null,
                    totalCount: `938`,
                    timePercentilesFromPrev: [],
                    timePercentilesFromStart: [],
                  },
                ],
                segments: [{values: [], value: `insights`, label: `Report name`}],
                totalCount: `938`,
                step: `2`,
                type: `NORMAL`,
                event: `Viewed report`,
                isComputed: false,
              },
              {
                breakdowns: [
                  {
                    timeBucketsFromStart: null,
                    segments: [],
                    timeBucketsFromPrev: null,
                    totalCount: `1624`,
                    timePercentilesFromPrev: [],
                    timePercentilesFromStart: [],
                  },
                ],
                segments: [{values: [], value: `live`, label: `Report name`}],
                totalCount: `1624`,
                step: `2`,
                type: `NORMAL`,
                event: `Viewed report`,
                isComputed: false,
              },
              {
                breakdowns: [
                  {
                    timeBucketsFromStart: null,
                    segments: [],
                    timeBucketsFromPrev: null,
                    totalCount: `191`,
                    timePercentilesFromPrev: [],
                    timePercentilesFromStart: [],
                  },
                ],
                segments: [{values: [], value: `dashboard`, label: `Report name`}],
                totalCount: `191`,
                step: `2`,
                type: `NORMAL`,
                event: `Viewed report`,
                isComputed: false,
              },
              {
                breakdowns: [
                  {
                    timeBucketsFromStart: null,
                    segments: [],
                    timeBucketsFromPrev: null,
                    totalCount: `417`,
                    timePercentilesFromPrev: [],
                    timePercentilesFromStart: [],
                  },
                ],
                segments: [{values: [], value: `explore`, label: `Report name`}],
                totalCount: `417`,
                step: `2`,
                type: `NORMAL`,
                event: `Viewed report`,
                isComputed: false,
              },
              {
                breakdowns: [
                  {
                    timeBucketsFromStart: null,
                    segments: [],
                    timeBucketsFromPrev: null,
                    totalCount: `118`,
                    timePercentilesFromPrev: [],
                    timePercentilesFromStart: [],
                  },
                ],
                segments: [{values: [], value: `funnels`, label: `Report name`}],
                totalCount: `118`,
                step: `2`,
                type: `NORMAL`,
                event: `Viewed report`,
                isComputed: false,
              },
              {
                breakdowns: [
                  {
                    timeBucketsFromStart: null,
                    segments: [],
                    timeBucketsFromPrev: null,
                    totalCount: `840`,
                    timePercentilesFromPrev: [],
                    timePercentilesFromStart: [],
                  },
                ],
                segments: [],
                totalCount: `840`,
                step: `2`,
                type: `PRUNED`,
                event: ``,
                isComputed: false,
              },
              {
                breakdowns: [
                  {
                    timeBucketsFromStart: null,
                    segments: [],
                    timeBucketsFromPrev: null,
                    totalCount: `245`,
                    timePercentilesFromPrev: [],
                    timePercentilesFromStart: [],
                  },
                ],
                segments: [],
                totalCount: `245`,
                step: `2`,
                type: `DROPOFF`,
                event: ``,
                isComputed: false,
              },
            ],
            type: `NORMAL`,
            event: `Viewed report`,
            isComputed: false,
          },
          {
            breakdowns: [
              {
                timeBucketsFromStart: null,
                segments: [],
                timeBucketsFromPrev: null,
                totalCount: `3771`,
                timePercentilesFromPrev: [],
                timePercentilesFromStart: [],
              },
            ],
            segments: [{values: [], value: `dashboard`, label: `Report name`}],
            totalCount: `3771`,
            edges: [
              {
                breakdowns: [
                  {
                    timeBucketsFromStart: null,
                    segments: [],
                    timeBucketsFromPrev: null,
                    totalCount: `927`,
                    timePercentilesFromPrev: [],
                    timePercentilesFromStart: [],
                  },
                ],
                segments: [{values: [], value: `insights`, label: `Report name`}],
                totalCount: `927`,
                step: `2`,
                type: `NORMAL`,
                event: `Viewed report`,
                isComputed: false,
              },
              {
                breakdowns: [
                  {
                    timeBucketsFromStart: null,
                    segments: [],
                    timeBucketsFromPrev: null,
                    totalCount: `1906`,
                    timePercentilesFromPrev: [],
                    timePercentilesFromStart: [],
                  },
                ],
                segments: [{values: [], value: `dashboard`, label: `Report name`}],
                totalCount: `1906`,
                step: `2`,
                type: `NORMAL`,
                event: `Viewed report`,
                isComputed: false,
              },
              {
                breakdowns: [
                  {
                    timeBucketsFromStart: null,
                    segments: [],
                    timeBucketsFromPrev: null,
                    totalCount: `87`,
                    timePercentilesFromPrev: [],
                    timePercentilesFromStart: [],
                  },
                ],
                segments: [{values: [], value: `live`, label: `Report name`}],
                totalCount: `87`,
                step: `2`,
                type: `NORMAL`,
                event: `Viewed report`,
                isComputed: false,
              },
              {
                breakdowns: [
                  {
                    timeBucketsFromStart: null,
                    segments: [],
                    timeBucketsFromPrev: null,
                    totalCount: `178`,
                    timePercentilesFromPrev: [],
                    timePercentilesFromStart: [],
                  },
                ],
                segments: [{values: [], value: `funnels`, label: `Report name`}],
                totalCount: `178`,
                step: `2`,
                type: `NORMAL`,
                event: `Viewed report`,
                isComputed: false,
              },
              {
                breakdowns: [
                  {
                    timeBucketsFromStart: null,
                    segments: [],
                    timeBucketsFromPrev: null,
                    totalCount: `151`,
                    timePercentilesFromPrev: [],
                    timePercentilesFromStart: [],
                  },
                ],
                segments: [{values: [], value: `explore`, label: `Report name`}],
                totalCount: `151`,
                step: `2`,
                type: `NORMAL`,
                event: `Viewed report`,
                isComputed: false,
              },
              {
                breakdowns: [
                  {
                    timeBucketsFromStart: null,
                    segments: [],
                    timeBucketsFromPrev: null,
                    totalCount: `301`,
                    timePercentilesFromPrev: [],
                    timePercentilesFromStart: [],
                  },
                ],
                segments: [],
                totalCount: `301`,
                step: `2`,
                type: `PRUNED`,
                event: ``,
                isComputed: false,
              },
              {
                breakdowns: [
                  {
                    timeBucketsFromStart: null,
                    segments: [],
                    timeBucketsFromPrev: null,
                    totalCount: `221`,
                    timePercentilesFromPrev: [],
                    timePercentilesFromStart: [],
                  },
                ],
                segments: [],
                totalCount: `221`,
                step: `2`,
                type: `DROPOFF`,
                event: ``,
                isComputed: false,
              },
            ],
            type: `NORMAL`,
            event: `Viewed report`,
            isComputed: false,
          },
          {
            breakdowns: [
              {
                timeBucketsFromStart: null,
                segments: [],
                timeBucketsFromPrev: null,
                totalCount: `1958`,
                timePercentilesFromPrev: [],
                timePercentilesFromStart: [],
              },
            ],
            segments: [{values: [], value: `user_settings`, label: `Report name`}],
            totalCount: `1958`,
            edges: [
              {
                breakdowns: [
                  {
                    timeBucketsFromStart: null,
                    segments: [],
                    timeBucketsFromPrev: null,
                    totalCount: `614`,
                    timePercentilesFromPrev: [],
                    timePercentilesFromStart: [],
                  },
                ],
                segments: [{values: [], value: `insights`, label: `Report name`}],
                totalCount: `614`,
                step: `2`,
                type: `NORMAL`,
                event: `Viewed report`,
                isComputed: false,
              },
              {
                breakdowns: [
                  {
                    timeBucketsFromStart: null,
                    segments: [],
                    timeBucketsFromPrev: null,
                    totalCount: `77`,
                    timePercentilesFromPrev: [],
                    timePercentilesFromStart: [],
                  },
                ],
                segments: [{values: [], value: `explore`, label: `Report name`}],
                totalCount: `77`,
                step: `2`,
                type: `NORMAL`,
                event: `Viewed report`,
                isComputed: false,
              },
              {
                breakdowns: [
                  {
                    timeBucketsFromStart: null,
                    segments: [],
                    timeBucketsFromPrev: null,
                    totalCount: `229`,
                    timePercentilesFromPrev: [],
                    timePercentilesFromStart: [],
                  },
                ],
                segments: [{values: [], value: `dashboard`, label: `Report name`}],
                totalCount: `229`,
                step: `2`,
                type: `NORMAL`,
                event: `Viewed report`,
                isComputed: false,
              },
              {
                breakdowns: [
                  {
                    timeBucketsFromStart: null,
                    segments: [],
                    timeBucketsFromPrev: null,
                    totalCount: `32`,
                    timePercentilesFromPrev: [],
                    timePercentilesFromStart: [],
                  },
                ],
                segments: [{values: [], value: `live`, label: `Report name`}],
                totalCount: `32`,
                step: `2`,
                type: `NORMAL`,
                event: `Viewed report`,
                isComputed: false,
              },
              {
                breakdowns: [
                  {
                    timeBucketsFromStart: null,
                    segments: [],
                    timeBucketsFromPrev: null,
                    totalCount: `13`,
                    timePercentilesFromPrev: [],
                    timePercentilesFromStart: [],
                  },
                ],
                segments: [{values: [], value: `funnels`, label: `Report name`}],
                totalCount: `13`,
                step: `2`,
                type: `NORMAL`,
                event: `Viewed report`,
                isComputed: false,
              },
              {
                breakdowns: [
                  {
                    timeBucketsFromStart: null,
                    segments: [],
                    timeBucketsFromPrev: null,
                    totalCount: `719`,
                    timePercentilesFromPrev: [],
                    timePercentilesFromStart: [],
                  },
                ],
                segments: [],
                totalCount: `719`,
                step: `2`,
                type: `PRUNED`,
                event: ``,
                isComputed: false,
              },
              {
                breakdowns: [
                  {
                    timeBucketsFromStart: null,
                    segments: [],
                    timeBucketsFromPrev: null,
                    totalCount: `274`,
                    timePercentilesFromPrev: [],
                    timePercentilesFromStart: [],
                  },
                ],
                segments: [],
                totalCount: `274`,
                step: `2`,
                type: `DROPOFF`,
                event: ``,
                isComputed: false,
              },
            ],
            type: `NORMAL`,
            event: `Viewed report`,
            isComputed: false,
          },
          {
            breakdowns: [
              {
                timeBucketsFromStart: null,
                segments: [],
                timeBucketsFromPrev: null,
                totalCount: `5638`,
                timePercentilesFromPrev: [],
                timePercentilesFromStart: [],
              },
            ],
            segments: [],
            totalCount: `5638`,
            edges: [
              {
                breakdowns: [
                  {
                    timeBucketsFromStart: null,
                    segments: [],
                    timeBucketsFromPrev: null,
                    totalCount: `314`,
                    timePercentilesFromPrev: [],
                    timePercentilesFromStart: [],
                  },
                ],
                segments: [{values: [], value: `explore`, label: `Report name`}],
                totalCount: `314`,
                step: `2`,
                type: `NORMAL`,
                event: `Viewed report`,
                isComputed: false,
              },
              {
                breakdowns: [
                  {
                    timeBucketsFromStart: null,
                    segments: [],
                    timeBucketsFromPrev: null,
                    totalCount: `1125`,
                    timePercentilesFromPrev: [],
                    timePercentilesFromStart: [],
                  },
                ],
                segments: [{values: [], value: `funnels`, label: `Report name`}],
                totalCount: `1125`,
                step: `2`,
                type: `NORMAL`,
                event: `Viewed report`,
                isComputed: false,
              },
              {
                breakdowns: [
                  {
                    timeBucketsFromStart: null,
                    segments: [],
                    timeBucketsFromPrev: null,
                    totalCount: `947`,
                    timePercentilesFromPrev: [],
                    timePercentilesFromStart: [],
                  },
                ],
                segments: [{values: [], value: `insights`, label: `Report name`}],
                totalCount: `947`,
                step: `2`,
                type: `NORMAL`,
                event: `Viewed report`,
                isComputed: false,
              },
              {
                breakdowns: [
                  {
                    timeBucketsFromStart: null,
                    segments: [],
                    timeBucketsFromPrev: null,
                    totalCount: `208`,
                    timePercentilesFromPrev: [],
                    timePercentilesFromStart: [],
                  },
                ],
                segments: [{values: [], value: `live`, label: `Report name`}],
                totalCount: `208`,
                step: `2`,
                type: `NORMAL`,
                event: `Viewed report`,
                isComputed: false,
              },
              {
                breakdowns: [
                  {
                    timeBucketsFromStart: null,
                    segments: [],
                    timeBucketsFromPrev: null,
                    totalCount: `335`,
                    timePercentilesFromPrev: [],
                    timePercentilesFromStart: [],
                  },
                ],
                segments: [{values: [], value: `dashboard`, label: `Report name`}],
                totalCount: `335`,
                step: `2`,
                type: `NORMAL`,
                event: `Viewed report`,
                isComputed: false,
              },
              {
                breakdowns: [
                  {
                    timeBucketsFromStart: null,
                    segments: [],
                    timeBucketsFromPrev: null,
                    totalCount: `2386`,
                    timePercentilesFromPrev: [],
                    timePercentilesFromStart: [],
                  },
                ],
                segments: [],
                totalCount: `2386`,
                step: `2`,
                type: `PRUNED`,
                event: ``,
                isComputed: false,
              },
              {
                breakdowns: [
                  {
                    timeBucketsFromStart: null,
                    segments: [],
                    timeBucketsFromPrev: null,
                    totalCount: `323`,
                    timePercentilesFromPrev: [],
                    timePercentilesFromStart: [],
                  },
                ],
                segments: [],
                totalCount: `323`,
                step: `2`,
                type: `DROPOFF`,
                event: ``,
                isComputed: false,
              },
            ],
            type: `PRUNED`,
            event: ``,
            isComputed: false,
          },
          {
            breakdowns: [
              {
                timeBucketsFromStart: null,
                segments: [],
                timeBucketsFromPrev: null,
                totalCount: `3329`,
                timePercentilesFromPrev: [],
                timePercentilesFromStart: [],
              },
            ],
            segments: [],
            totalCount: `3329`,
            edges: [
              {
                breakdowns: [
                  {
                    timeBucketsFromStart: null,
                    segments: [],
                    timeBucketsFromPrev: null,
                    totalCount: `3329`,
                    timePercentilesFromPrev: [],
                    timePercentilesFromStart: [],
                  },
                ],
                segments: [],
                totalCount: `3329`,
                step: `2`,
                type: `DROPOFF`,
                event: ``,
                isComputed: false,
              },
            ],
            type: `DROPOFF`,
            event: ``,
            isComputed: false,
          },
        ],
      },
      {
        nodes: [
          {
            breakdowns: [
              {
                timeBucketsFromStart: null,
                segments: [],
                timeBucketsFromPrev: null,
                totalCount: `11301`,
                timePercentilesFromPrev: [],
                timePercentilesFromStart: [],
              },
            ],
            segments: [{values: [], value: `insights`, label: `Report name`}],
            totalCount: `11301`,
            edges: [
              {
                breakdowns: [
                  {
                    timeBucketsFromStart: null,
                    segments: [],
                    timeBucketsFromPrev: null,
                    totalCount: `5967`,
                    timePercentilesFromPrev: [],
                    timePercentilesFromStart: [],
                  },
                ],
                segments: [{values: [], value: `insights`, label: `Report name`}],
                totalCount: `5967`,
                step: `3`,
                type: `NORMAL`,
                event: `Viewed report`,
                isComputed: false,
              },
              {
                breakdowns: [
                  {
                    timeBucketsFromStart: null,
                    segments: [],
                    timeBucketsFromPrev: null,
                    totalCount: `1312`,
                    timePercentilesFromPrev: [],
                    timePercentilesFromStart: [],
                  },
                ],
                segments: [{values: [], value: `live`, label: `Report name`}],
                totalCount: `1312`,
                step: `3`,
                type: `NORMAL`,
                event: `Viewed report`,
                isComputed: false,
              },
              {
                breakdowns: [
                  {
                    timeBucketsFromStart: null,
                    segments: [],
                    timeBucketsFromPrev: null,
                    totalCount: `791`,
                    timePercentilesFromPrev: [],
                    timePercentilesFromStart: [],
                  },
                ],
                segments: [{values: [], value: `dashboard`, label: `Report name`}],
                totalCount: `791`,
                step: `3`,
                type: `NORMAL`,
                event: `Viewed report`,
                isComputed: false,
              },
              {
                breakdowns: [
                  {
                    timeBucketsFromStart: null,
                    segments: [],
                    timeBucketsFromPrev: null,
                    totalCount: `635`,
                    timePercentilesFromPrev: [],
                    timePercentilesFromStart: [],
                  },
                ],
                segments: [{values: [], value: `explore`, label: `Report name`}],
                totalCount: `635`,
                step: `3`,
                type: `NORMAL`,
                event: `Viewed report`,
                isComputed: false,
              },
              {
                breakdowns: [
                  {
                    timeBucketsFromStart: null,
                    segments: [],
                    timeBucketsFromPrev: null,
                    totalCount: `443`,
                    timePercentilesFromPrev: [],
                    timePercentilesFromStart: [],
                  },
                ],
                segments: [{values: [], value: `funnels`, label: `Report name`}],
                totalCount: `443`,
                step: `3`,
                type: `NORMAL`,
                event: `Viewed report`,
                isComputed: false,
              },
              {
                breakdowns: [
                  {
                    timeBucketsFromStart: null,
                    segments: [],
                    timeBucketsFromPrev: null,
                    totalCount: `1385`,
                    timePercentilesFromPrev: [],
                    timePercentilesFromStart: [],
                  },
                ],
                segments: [],
                totalCount: `1385`,
                step: `3`,
                type: `PRUNED`,
                event: ``,
                isComputed: false,
              },
              {
                breakdowns: [
                  {
                    timeBucketsFromStart: null,
                    segments: [],
                    timeBucketsFromPrev: null,
                    totalCount: `768`,
                    timePercentilesFromPrev: [],
                    timePercentilesFromStart: [],
                  },
                ],
                segments: [],
                totalCount: `768`,
                step: `3`,
                type: `DROPOFF`,
                event: ``,
                isComputed: false,
              },
            ],
            type: `NORMAL`,
            event: `Viewed report`,
            isComputed: false,
          },
          {
            breakdowns: [
              {
                timeBucketsFromStart: null,
                segments: [],
                timeBucketsFromPrev: null,
                totalCount: `4393`,
                timePercentilesFromPrev: [],
                timePercentilesFromStart: [],
              },
            ],
            segments: [{values: [], value: `explore`, label: `Report name`}],
            totalCount: `4393`,
            edges: [
              {
                breakdowns: [
                  {
                    timeBucketsFromStart: null,
                    segments: [],
                    timeBucketsFromPrev: null,
                    totalCount: `454`,
                    timePercentilesFromPrev: [],
                    timePercentilesFromStart: [],
                  },
                ],
                segments: [{values: [], value: `insights`, label: `Report name`}],
                totalCount: `454`,
                step: `3`,
                type: `NORMAL`,
                event: `Viewed report`,
                isComputed: false,
              },
              {
                breakdowns: [
                  {
                    timeBucketsFromStart: null,
                    segments: [],
                    timeBucketsFromPrev: null,
                    totalCount: `2894`,
                    timePercentilesFromPrev: [],
                    timePercentilesFromStart: [],
                  },
                ],
                segments: [{values: [], value: `explore`, label: `Report name`}],
                totalCount: `2894`,
                step: `3`,
                type: `NORMAL`,
                event: `Viewed report`,
                isComputed: false,
              },
              {
                breakdowns: [
                  {
                    timeBucketsFromStart: null,
                    segments: [],
                    timeBucketsFromPrev: null,
                    totalCount: `44`,
                    timePercentilesFromPrev: [],
                    timePercentilesFromStart: [],
                  },
                ],
                segments: [{values: [], value: `funnels`, label: `Report name`}],
                totalCount: `44`,
                step: `3`,
                type: `NORMAL`,
                event: `Viewed report`,
                isComputed: false,
              },
              {
                breakdowns: [
                  {
                    timeBucketsFromStart: null,
                    segments: [],
                    timeBucketsFromPrev: null,
                    totalCount: `168`,
                    timePercentilesFromPrev: [],
                    timePercentilesFromStart: [],
                  },
                ],
                segments: [{values: [], value: `live`, label: `Report name`}],
                totalCount: `168`,
                step: `3`,
                type: `NORMAL`,
                event: `Viewed report`,
                isComputed: false,
              },
              {
                breakdowns: [
                  {
                    timeBucketsFromStart: null,
                    segments: [],
                    timeBucketsFromPrev: null,
                    totalCount: `159`,
                    timePercentilesFromPrev: [],
                    timePercentilesFromStart: [],
                  },
                ],
                segments: [{values: [], value: `dashboard`, label: `Report name`}],
                totalCount: `159`,
                step: `3`,
                type: `NORMAL`,
                event: `Viewed report`,
                isComputed: false,
              },
              {
                breakdowns: [
                  {
                    timeBucketsFromStart: null,
                    segments: [],
                    timeBucketsFromPrev: null,
                    totalCount: `433`,
                    timePercentilesFromPrev: [],
                    timePercentilesFromStart: [],
                  },
                ],
                segments: [],
                totalCount: `433`,
                step: `3`,
                type: `PRUNED`,
                event: ``,
                isComputed: false,
              },
              {
                breakdowns: [
                  {
                    timeBucketsFromStart: null,
                    segments: [],
                    timeBucketsFromPrev: null,
                    totalCount: `241`,
                    timePercentilesFromPrev: [],
                    timePercentilesFromStart: [],
                  },
                ],
                segments: [],
                totalCount: `241`,
                step: `3`,
                type: `DROPOFF`,
                event: ``,
                isComputed: false,
              },
            ],
            type: `NORMAL`,
            event: `Viewed report`,
            isComputed: false,
          },
          {
            breakdowns: [
              {
                timeBucketsFromStart: null,
                segments: [],
                timeBucketsFromPrev: null,
                totalCount: `3643`,
                timePercentilesFromPrev: [],
                timePercentilesFromStart: [],
              },
            ],
            segments: [{values: [], value: `dashboard`, label: `Report name`}],
            totalCount: `3643`,
            edges: [
              {
                breakdowns: [
                  {
                    timeBucketsFromStart: null,
                    segments: [],
                    timeBucketsFromPrev: null,
                    totalCount: `172`,
                    timePercentilesFromPrev: [],
                    timePercentilesFromStart: [],
                  },
                ],
                segments: [{values: [], value: `explore`, label: `Report name`}],
                totalCount: `172`,
                step: `3`,
                type: `NORMAL`,
                event: `Viewed report`,
                isComputed: false,
              },
              {
                breakdowns: [
                  {
                    timeBucketsFromStart: null,
                    segments: [],
                    timeBucketsFromPrev: null,
                    totalCount: `649`,
                    timePercentilesFromPrev: [],
                    timePercentilesFromStart: [],
                  },
                ],
                segments: [{values: [], value: `insights`, label: `Report name`}],
                totalCount: `649`,
                step: `3`,
                type: `NORMAL`,
                event: `Viewed report`,
                isComputed: false,
              },
              {
                breakdowns: [
                  {
                    timeBucketsFromStart: null,
                    segments: [],
                    timeBucketsFromPrev: null,
                    totalCount: `2177`,
                    timePercentilesFromPrev: [],
                    timePercentilesFromStart: [],
                  },
                ],
                segments: [{values: [], value: `dashboard`, label: `Report name`}],
                totalCount: `2177`,
                step: `3`,
                type: `NORMAL`,
                event: `Viewed report`,
                isComputed: false,
              },
              {
                breakdowns: [
                  {
                    timeBucketsFromStart: null,
                    segments: [],
                    timeBucketsFromPrev: null,
                    totalCount: `158`,
                    timePercentilesFromPrev: [],
                    timePercentilesFromStart: [],
                  },
                ],
                segments: [{values: [], value: `funnels`, label: `Report name`}],
                totalCount: `158`,
                step: `3`,
                type: `NORMAL`,
                event: `Viewed report`,
                isComputed: false,
              },
              {
                breakdowns: [
                  {
                    timeBucketsFromStart: null,
                    segments: [],
                    timeBucketsFromPrev: null,
                    totalCount: `82`,
                    timePercentilesFromPrev: [],
                    timePercentilesFromStart: [],
                  },
                ],
                segments: [{values: [], value: `live`, label: `Report name`}],
                totalCount: `82`,
                step: `3`,
                type: `NORMAL`,
                event: `Viewed report`,
                isComputed: false,
              },
              {
                breakdowns: [
                  {
                    timeBucketsFromStart: null,
                    segments: [],
                    timeBucketsFromPrev: null,
                    totalCount: `252`,
                    timePercentilesFromPrev: [],
                    timePercentilesFromStart: [],
                  },
                ],
                segments: [],
                totalCount: `252`,
                step: `3`,
                type: `PRUNED`,
                event: ``,
                isComputed: false,
              },
              {
                breakdowns: [
                  {
                    timeBucketsFromStart: null,
                    segments: [],
                    timeBucketsFromPrev: null,
                    totalCount: `153`,
                    timePercentilesFromPrev: [],
                    timePercentilesFromStart: [],
                  },
                ],
                segments: [],
                totalCount: `153`,
                step: `3`,
                type: `DROPOFF`,
                event: ``,
                isComputed: false,
              },
            ],
            type: `NORMAL`,
            event: `Viewed report`,
            isComputed: false,
          },
          {
            breakdowns: [
              {
                timeBucketsFromStart: null,
                segments: [],
                timeBucketsFromPrev: null,
                totalCount: `3152`,
                timePercentilesFromPrev: [],
                timePercentilesFromStart: [],
              },
            ],
            segments: [{values: [], value: `live`, label: `Report name`}],
            totalCount: `3152`,
            edges: [
              {
                breakdowns: [
                  {
                    timeBucketsFromStart: null,
                    segments: [],
                    timeBucketsFromPrev: null,
                    totalCount: `291`,
                    timePercentilesFromPrev: [],
                    timePercentilesFromStart: [],
                  },
                ],
                segments: [{values: [], value: `explore`, label: `Report name`}],
                totalCount: `291`,
                step: `3`,
                type: `NORMAL`,
                event: `Viewed report`,
                isComputed: false,
              },
              {
                breakdowns: [
                  {
                    timeBucketsFromStart: null,
                    segments: [],
                    timeBucketsFromPrev: null,
                    totalCount: `613`,
                    timePercentilesFromPrev: [],
                    timePercentilesFromStart: [],
                  },
                ],
                segments: [{values: [], value: `insights`, label: `Report name`}],
                totalCount: `613`,
                step: `3`,
                type: `NORMAL`,
                event: `Viewed report`,
                isComputed: false,
              },
              {
                breakdowns: [
                  {
                    timeBucketsFromStart: null,
                    segments: [],
                    timeBucketsFromPrev: null,
                    totalCount: `1504`,
                    timePercentilesFromPrev: [],
                    timePercentilesFromStart: [],
                  },
                ],
                segments: [{values: [], value: `live`, label: `Report name`}],
                totalCount: `1504`,
                step: `3`,
                type: `NORMAL`,
                event: `Viewed report`,
                isComputed: false,
              },
              {
                breakdowns: [
                  {
                    timeBucketsFromStart: null,
                    segments: [],
                    timeBucketsFromPrev: null,
                    totalCount: `99`,
                    timePercentilesFromPrev: [],
                    timePercentilesFromStart: [],
                  },
                ],
                segments: [{values: [], value: `dashboard`, label: `Report name`}],
                totalCount: `99`,
                step: `3`,
                type: `NORMAL`,
                event: `Viewed report`,
                isComputed: false,
              },
              {
                breakdowns: [
                  {
                    timeBucketsFromStart: null,
                    segments: [],
                    timeBucketsFromPrev: null,
                    totalCount: `71`,
                    timePercentilesFromPrev: [],
                    timePercentilesFromStart: [],
                  },
                ],
                segments: [{values: [], value: `funnels`, label: `Report name`}],
                totalCount: `71`,
                step: `3`,
                type: `NORMAL`,
                event: `Viewed report`,
                isComputed: false,
              },
              {
                breakdowns: [
                  {
                    timeBucketsFromStart: null,
                    segments: [],
                    timeBucketsFromPrev: null,
                    totalCount: `393`,
                    timePercentilesFromPrev: [],
                    timePercentilesFromStart: [],
                  },
                ],
                segments: [],
                totalCount: `393`,
                step: `3`,
                type: `PRUNED`,
                event: ``,
                isComputed: false,
              },
              {
                breakdowns: [
                  {
                    timeBucketsFromStart: null,
                    segments: [],
                    timeBucketsFromPrev: null,
                    totalCount: `181`,
                    timePercentilesFromPrev: [],
                    timePercentilesFromStart: [],
                  },
                ],
                segments: [],
                totalCount: `181`,
                step: `3`,
                type: `DROPOFF`,
                event: ``,
                isComputed: false,
              },
            ],
            type: `NORMAL`,
            event: `Viewed report`,
            isComputed: false,
          },
          {
            breakdowns: [
              {
                timeBucketsFromStart: null,
                segments: [],
                timeBucketsFromPrev: null,
                totalCount: `1873`,
                timePercentilesFromPrev: [],
                timePercentilesFromStart: [],
              },
            ],
            segments: [{values: [], value: `funnels`, label: `Report name`}],
            totalCount: `1873`,
            edges: [
              {
                breakdowns: [
                  {
                    timeBucketsFromStart: null,
                    segments: [],
                    timeBucketsFromPrev: null,
                    totalCount: `363`,
                    timePercentilesFromPrev: [],
                    timePercentilesFromStart: [],
                  },
                ],
                segments: [{values: [], value: `insights`, label: `Report name`}],
                totalCount: `363`,
                step: `3`,
                type: `NORMAL`,
                event: `Viewed report`,
                isComputed: false,
              },
              {
                breakdowns: [
                  {
                    timeBucketsFromStart: null,
                    segments: [],
                    timeBucketsFromPrev: null,
                    totalCount: `860`,
                    timePercentilesFromPrev: [],
                    timePercentilesFromStart: [],
                  },
                ],
                segments: [{values: [], value: `funnels`, label: `Report name`}],
                totalCount: `860`,
                step: `3`,
                type: `NORMAL`,
                event: `Viewed report`,
                isComputed: false,
              },
              {
                breakdowns: [
                  {
                    timeBucketsFromStart: null,
                    segments: [],
                    timeBucketsFromPrev: null,
                    totalCount: `55`,
                    timePercentilesFromPrev: [],
                    timePercentilesFromStart: [],
                  },
                ],
                segments: [{values: [], value: `explore`, label: `Report name`}],
                totalCount: `55`,
                step: `3`,
                type: `NORMAL`,
                event: `Viewed report`,
                isComputed: false,
              },
              {
                breakdowns: [
                  {
                    timeBucketsFromStart: null,
                    segments: [],
                    timeBucketsFromPrev: null,
                    totalCount: `137`,
                    timePercentilesFromPrev: [],
                    timePercentilesFromStart: [],
                  },
                ],
                segments: [{values: [], value: `dashboard`, label: `Report name`}],
                totalCount: `137`,
                step: `3`,
                type: `NORMAL`,
                event: `Viewed report`,
                isComputed: false,
              },
              {
                breakdowns: [
                  {
                    timeBucketsFromStart: null,
                    segments: [],
                    timeBucketsFromPrev: null,
                    totalCount: `75`,
                    timePercentilesFromPrev: [],
                    timePercentilesFromStart: [],
                  },
                ],
                segments: [{values: [], value: `live`, label: `Report name`}],
                totalCount: `75`,
                step: `3`,
                type: `NORMAL`,
                event: `Viewed report`,
                isComputed: false,
              },
              {
                breakdowns: [
                  {
                    timeBucketsFromStart: null,
                    segments: [],
                    timeBucketsFromPrev: null,
                    totalCount: `270`,
                    timePercentilesFromPrev: [],
                    timePercentilesFromStart: [],
                  },
                ],
                segments: [],
                totalCount: `270`,
                step: `3`,
                type: `PRUNED`,
                event: ``,
                isComputed: false,
              },
              {
                breakdowns: [
                  {
                    timeBucketsFromStart: null,
                    segments: [],
                    timeBucketsFromPrev: null,
                    totalCount: `113`,
                    timePercentilesFromPrev: [],
                    timePercentilesFromStart: [],
                  },
                ],
                segments: [],
                totalCount: `113`,
                step: `3`,
                type: `DROPOFF`,
                event: ``,
                isComputed: false,
              },
            ],
            type: `NORMAL`,
            event: `Viewed report`,
            isComputed: false,
          },
          {
            breakdowns: [
              {
                timeBucketsFromStart: null,
                segments: [],
                timeBucketsFromPrev: null,
                totalCount: `5922`,
                timePercentilesFromPrev: [],
                timePercentilesFromStart: [],
              },
            ],
            segments: [],
            totalCount: `5922`,
            edges: [
              {
                breakdowns: [
                  {
                    timeBucketsFromStart: null,
                    segments: [],
                    timeBucketsFromPrev: null,
                    totalCount: `1221`,
                    timePercentilesFromPrev: [],
                    timePercentilesFromStart: [],
                  },
                ],
                segments: [{values: [], value: `insights`, label: `Report name`}],
                totalCount: `1221`,
                step: `3`,
                type: `NORMAL`,
                event: `Viewed report`,
                isComputed: false,
              },
              {
                breakdowns: [
                  {
                    timeBucketsFromStart: null,
                    segments: [],
                    timeBucketsFromPrev: null,
                    totalCount: `393`,
                    timePercentilesFromPrev: [],
                    timePercentilesFromStart: [],
                  },
                ],
                segments: [{values: [], value: `dashboard`, label: `Report name`}],
                totalCount: `393`,
                step: `3`,
                type: `NORMAL`,
                event: `Viewed report`,
                isComputed: false,
              },
              {
                breakdowns: [
                  {
                    timeBucketsFromStart: null,
                    segments: [],
                    timeBucketsFromPrev: null,
                    totalCount: `362`,
                    timePercentilesFromPrev: [],
                    timePercentilesFromStart: [],
                  },
                ],
                segments: [{values: [], value: `explore`, label: `Report name`}],
                totalCount: `362`,
                step: `3`,
                type: `NORMAL`,
                event: `Viewed report`,
                isComputed: false,
              },
              {
                breakdowns: [
                  {
                    timeBucketsFromStart: null,
                    segments: [],
                    timeBucketsFromPrev: null,
                    totalCount: `306`,
                    timePercentilesFromPrev: [],
                    timePercentilesFromStart: [],
                  },
                ],
                segments: [{values: [], value: `funnels`, label: `Report name`}],
                totalCount: `306`,
                step: `3`,
                type: `NORMAL`,
                event: `Viewed report`,
                isComputed: false,
              },
              {
                breakdowns: [
                  {
                    timeBucketsFromStart: null,
                    segments: [],
                    timeBucketsFromPrev: null,
                    totalCount: `185`,
                    timePercentilesFromPrev: [],
                    timePercentilesFromStart: [],
                  },
                ],
                segments: [{values: [], value: `live`, label: `Report name`}],
                totalCount: `185`,
                step: `3`,
                type: `NORMAL`,
                event: `Viewed report`,
                isComputed: false,
              },
              {
                breakdowns: [
                  {
                    timeBucketsFromStart: null,
                    segments: [],
                    timeBucketsFromPrev: null,
                    totalCount: `3027`,
                    timePercentilesFromPrev: [],
                    timePercentilesFromStart: [],
                  },
                ],
                segments: [],
                totalCount: `3027`,
                step: `3`,
                type: `PRUNED`,
                event: ``,
                isComputed: false,
              },
              {
                breakdowns: [
                  {
                    timeBucketsFromStart: null,
                    segments: [],
                    timeBucketsFromPrev: null,
                    totalCount: `428`,
                    timePercentilesFromPrev: [],
                    timePercentilesFromStart: [],
                  },
                ],
                segments: [],
                totalCount: `428`,
                step: `3`,
                type: `DROPOFF`,
                event: ``,
                isComputed: false,
              },
            ],
            type: `PRUNED`,
            event: ``,
            isComputed: false,
          },
          {
            breakdowns: [
              {
                timeBucketsFromStart: null,
                segments: [],
                timeBucketsFromPrev: null,
                totalCount: `5647`,
                timePercentilesFromPrev: [],
                timePercentilesFromStart: [],
              },
            ],
            segments: [],
            totalCount: `5647`,
            edges: [
              {
                breakdowns: [
                  {
                    timeBucketsFromStart: null,
                    segments: [],
                    timeBucketsFromPrev: null,
                    totalCount: `5647`,
                    timePercentilesFromPrev: [],
                    timePercentilesFromStart: [],
                  },
                ],
                segments: [],
                totalCount: `5647`,
                step: `3`,
                type: `DROPOFF`,
                event: ``,
                isComputed: false,
              },
            ],
            type: `DROPOFF`,
            event: ``,
            isComputed: false,
          },
        ],
      },
      {
        nodes: [
          {
            breakdowns: [
              {
                timeBucketsFromStart: null,
                segments: [],
                timeBucketsFromPrev: null,
                totalCount: `9267`,
                timePercentilesFromPrev: [],
                timePercentilesFromStart: [],
              },
            ],
            segments: [{values: [], value: `insights`, label: `Report name`}],
            totalCount: `9267`,
            edges: [],
            type: `NORMAL`,
            event: `Viewed report`,
            isComputed: false,
          },
          {
            breakdowns: [
              {
                timeBucketsFromStart: null,
                segments: [],
                timeBucketsFromPrev: null,
                totalCount: `4409`,
                timePercentilesFromPrev: [],
                timePercentilesFromStart: [],
              },
            ],
            segments: [{values: [], value: `explore`, label: `Report name`}],
            totalCount: `4409`,
            edges: [],
            type: `NORMAL`,
            event: `Viewed report`,
            isComputed: false,
          },
          {
            breakdowns: [
              {
                timeBucketsFromStart: null,
                segments: [],
                timeBucketsFromPrev: null,
                totalCount: `3756`,
                timePercentilesFromPrev: [],
                timePercentilesFromStart: [],
              },
            ],
            segments: [{values: [], value: `dashboard`, label: `Report name`}],
            totalCount: `3756`,
            edges: [],
            type: `NORMAL`,
            event: `Viewed report`,
            isComputed: false,
          },
          {
            breakdowns: [
              {
                timeBucketsFromStart: null,
                segments: [],
                timeBucketsFromPrev: null,
                totalCount: `3326`,
                timePercentilesFromPrev: [],
                timePercentilesFromStart: [],
              },
            ],
            segments: [{values: [], value: `live`, label: `Report name`}],
            totalCount: `3326`,
            edges: [],
            type: `NORMAL`,
            event: `Viewed report`,
            isComputed: false,
          },
          {
            breakdowns: [
              {
                timeBucketsFromStart: null,
                segments: [],
                timeBucketsFromPrev: null,
                totalCount: `1882`,
                timePercentilesFromPrev: [],
                timePercentilesFromStart: [],
              },
            ],
            segments: [{values: [], value: `funnels`, label: `Report name`}],
            totalCount: `1882`,
            edges: [],
            type: `NORMAL`,
            event: `Viewed report`,
            isComputed: false,
          },
          {
            breakdowns: [
              {
                timeBucketsFromStart: null,
                segments: [],
                timeBucketsFromPrev: null,
                totalCount: `5760`,
                timePercentilesFromPrev: [],
                timePercentilesFromStart: [],
              },
            ],
            segments: [],
            totalCount: `5760`,
            edges: [],
            type: `PRUNED`,
            event: ``,
            isComputed: false,
          },
          {
            breakdowns: [
              {
                timeBucketsFromStart: null,
                segments: [],
                timeBucketsFromPrev: null,
                totalCount: `7531`,
                timePercentilesFromPrev: [],
                timePercentilesFromStart: [],
              },
            ],
            segments: [],
            totalCount: `7531`,
            edges: [],
            type: `DROPOFF`,
            event: ``,
            isComputed: false,
          },
        ],
      },
    ],
  },
  [{forward: 4}],
);
